import {
  ALL_MODULES,
  getTranslatedText,
  ENTITY_MAP,
  INVOICE_STATUS,
  getModulePathName,
  ALL_SHARD_MODULES
} from '@nile/components';
import {
  AccountClient,
  getApiMethodAndKeyNames,
  apiResolver,
  GET_CUSTOM_FIELD_BY_NAME,
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA,
  TicketClient,
  GET_FIELD
} from '@nile/graphql';
import { includes } from 'lodash';
import { useQuery } from '@apollo/client';

/**
 * For entity type, if we want to call a specif api, this method will be called.
 * @param {object} item
 */
function getQuery(item) {
  const entity = item?.name?.split('.')[0] || '';
  switch (entity) {
    case 'accountManager':
      return GET_TECHNICIANS_BY_CRITERIA;
    default:
      return GET_REQUESTERS_BY_CRITERIA;
  }
}

function formatOperatorValues(allOperators, operator, intl) {
  return allOperators.getRuleBuilderOperators.operator_placeholders[
    operator
  ]?.map((el) => {
    return {
      ...el,
      label: getTranslatedText(intl, el.key),
      value: getTranslatedText(intl, el.key),
      name: el.key
    };
  });
}

/**
 * This method gives the query and client using which the API calls will be made
 * after selecting the attribute
 * @param {object} item
 * @param {String} operator
 */

function getPropValues(item, operator, allOperators, intl) {
  if (item?.name) {
    if (item.isCustom) {
      if (includes(['date', 'datetime'], item.dataType) && operator) {
        return formatOperatorValues(allOperators, operator, intl);
      }

      let module = 'billing';
      let columnName = item?.name;
      if (item.name.split('.')?.length > 1) {
        module = item.name.split('.')[item.name.split('.').length - 2];
        columnName = item.name.split('.').pop();
      }

      return AccountClient.query({
        query: GET_FIELD,
        variables: {
          input: {
            columnName: columnName,
            entity: ENTITY_MAP[module] || module
          }
        }
      });
    }
    const { module, pathname } = getModulePathName(item, 'invoice');

    const query = apiResolver[ENTITY_MAP[module]][pathname]?.api;
    const client = apiResolver[ENTITY_MAP[module]][pathname]?.client;
    const variables =
      apiResolver[ENTITY_MAP[module]][pathname]?.variables || {};

    if (query && client) {
      return client.query({
        query: query,
        variables: variables
      });
    }
    if (operator) {
      return formatOperatorValues(allOperators, operator, intl);
    }
    return { client: AccountClient, query: getQuery(item) };
  }
  return {};
}

async function onInvoiceViewAttributeSelect(params) {
  const { item: field, operator, fields, allOperators, intl } = params;
  const allFields = fields;
  const selectedField = allFields.find((el) => el.name === field);

  // if (selectedField?.name === 'statusEnum') {
  //   const { data: invoiceStatus, loading: invoiceStatusLoading } = useQuery(
  //     GET_INVOICE_STATUS,
  //     {
  //       client: AccountClient
  //     }
  //   );
  //   return invoiceStatus?.getInvoiceStatus?.map((status) => {
  //     return {
  //       name: status.charAt(0).toUpperCase() + status.slice(1),
  //       value: status,
  //       label: status.charAt(0).toUpperCase() + status.slice(1)
  //     };
  //   });
  // }

  if (selectedField?.dataType === 'boolean') {
    return [
      {
        name: 'true',
        label: 'true',
        value: true
      },
      {
        name: 'false',
        label: 'false',
        value: false
      }
    ];
  }

  if (field.split('.')?.length > 1) {
    const ent = field.split('.')[0];
    if (
      ent !== 'site' &&
      ent !== 'client' &&
      ent !== 'paymentMethod' &&
      ent !== 'invoicePaymentTerm'
    )
      return getPropValues(selectedField, null, allOperators);
  }

  const allValues = await getPropValues(
    selectedField,
    operator,
    allOperators,
    intl
  );
  let res = [];

  if (selectedField?.name) {
    const { module, pathname } = getModulePathName(selectedField, 'invoice');
    const apiMethodAndKeyNames = getApiMethodAndKeyNames(ENTITY_MAP[module]);
    let method = apiMethodAndKeyNames[pathname]?.method;
    const key = apiMethodAndKeyNames[pathname]?.key;
    const nestedKey = apiMethodAndKeyNames[pathname]?.nestedKey;
    const nestedTo = apiMethodAndKeyNames[pathname]?.nestedTo;
    if (nestedTo) {
      allValues?.data[method]?.forEach((el) => {
        res = res.concat(
          el[[nestedTo]].map((c) => {
            return {
              name: c[key],
              value: c[key],
              label: c[key]
            };
          })
        );
      });
    } else if (operator === 'on') {
      res = allValues;
    } else if (selectedField?.isCustom) {
      method = 'getField';
      res = allValues?.data
        ? allValues.data[method].options.map((el) => {
            return {
              name: el?.value,
              value: el?.value,
              label: el?.value
            };
          })
        : [];
    } else if (nestedKey) {
      res = allValues?.data?.[method]?.[nestedKey]
        ? allValues.data?.[method]?.[nestedKey].map((el) => {
            return {
              name: el[key],
              value: el[key],
              label: el[key]
            };
          })
        : [];
    } else {
      res = allValues?.data
        ? allValues.data[method].map((el) => {
            return {
              name: key ? el[key] : el,
              value: key ? el[key] : el,
              label: key ? el[key] : el
            };
          })
        : [];
    }
  }
  return res;
}

export { onInvoiceViewAttributeSelect };
